var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValentinesPromotionMobileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 138,
    viewBox: "0 0 167 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7737 0.933775C70.1804 -1.14589 83.6711 35.1308 83.6711 35.1308C83.6711 35.1308 98.925 -0.440645 131.187 3.22138C163.449 6.88341 181.922 44.2633 151.559 81.3627C118.393 121.889 81.1755 137.152 81.1755 137.152C81.1755 137.152 44.7451 120.081 13.6043 77.981C-14.9052 39.4348 5.37605 3.01344 37.7737 0.924724V0.933775Z",
    fill: "#DE5857"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.576 71.1361C33.9309 82.3844 44.7632 88.4878 49.7635 84.7715C54.7637 81.0552 52.0421 68.9208 43.6872 57.6725C35.3324 46.4242 24.5 40.3208 19.4998 44.0371C14.4995 47.7534 17.2212 59.8878 25.576 71.1361Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValentinesPromotionMobileIcon);
export default __webpack_public_path__ + "static/media/ValentinesPromotionMobileIcon.4430127e3cbe558248026dc4129c34a5.svg";
export { ForwardRef as ReactComponent };